import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type RrcUnit = DatabaseCode;

const gallons: RrcUnit = {
  code: "GALLONS",
  displayValue: {
    id: "common.entity.rrcdiscrepancybarrels.gallons",
    defaultMessage: "G",
  },
};

const barrels: RrcUnit = {
  code: "BARRELS",
  displayValue: {
    id: "common.entity.rrcdiscrepancybarrels.barrels",
    defaultMessage: "bbl.",
  },
};

const cubicYards: RrcUnit = {
  code: "CUBIC_YARDS",
  displayValue: {
    id: "common.entity.rrcdiscrepancybarrels.cubicyards",
    defaultMessage: "CY",
  },
};

const other: RrcUnit = {
  code: "OTHER",
  displayValue: {
    id: "common.entity.rrcdiscrepancybarrels.other",
    defaultMessage: "Other",
  },
};
export const rrcUnit = {
  gallons,
  barrels,
  cubicYards,
  other,
};

export const rrcUnits: RrcUnit[] = Object.values(rrcUnit);

export const toRrcUnit = (code: string): RrcUnit =>
  toDatabaseCode(code, rrcUnits);

export const toRrcUnitSafely = (
  code: string | undefined,
  defaultValue: RrcUnit | undefined = undefined
): RrcUnit | undefined => toDatabaseCodeSafely(code, rrcUnits, defaultValue);
